import React, { Component } from 'react';
import { getNewPreEFormException, getPreEFormException } from '../../../api/PreEForm';
import { confirmAlert } from 'react-confirm-alert';
import './styles.css';
import { getTeamMembers } from '../../../api';
import PreEExceptDialog from './preEDialog';
import axios from 'axios';
import { spinnerOff, spinnerOn } from '../../../components/Spinner';
import { oktaAuth } from 'oktaConfig';

class PreEExceptionDialog extends Component {
  constructor(props) {
    super(props);
    this.handleCheckboxSelect = this.handleCheckboxSelect.bind(this)
  }

  state = {
    situationText: '',
    timelineText: '',
    protectionSystemText: '',
    ddcSystemText: '',
    statusText: '',
    resolutionDateText: '',
    primaryContactText: '',
    approvalResponseDateText: '',
    closedCheckBoxText: false,
    titleText: '',
    error: '',
    editVisibleText: (this.props.exceptionId !== null),
    newFormSaveVisibleText: (this.props.exceptionId === null),
    teamMembers: [],
    exceptionId: this.props.exceptionId,
    preEnergizationFormException: {},
    preEAttachments: [],
    preEFormExceptions: null,

    fileList: {},
    Data: [],
    fileName: '',
    fileListName: '',
    noOfFilesError: null,
    fileSize: null,
    filesizeOk: true,
    events: [],
    fileCount: null,
    selectedIpsLocations: [],
    selectedLocationAssets: [],
    preFormExceptionMappings: []
  };


  async componentDidMount() {
    if (this.props.exceptionId === null) {
      let preEnergizationFormException = await getNewPreEFormException(this.props.formId);
      this.setState({ preEnergizationFormException });
      this.setState({ primaryContactText: preEnergizationFormException.primaryContact });
      this.setState({ statusText: 'Pending' });
      this.setState({ teamMembers: preEnergizationFormException.teams ? preEnergizationFormException.teams : await getTeamMembers(this.props.projectId) });
      //this.setState({selectedIpsLocations: preEnergizationFormException.preEnergizationFormException })
    } else {
      spinnerOn();
      let preEnergizationFormException = await getPreEFormException(this.props.exceptionId);
      this.setState({ preEnergizationFormException: preEnergizationFormException });
      this.setState({ titleText: preEnergizationFormException.title });
      this.setState({ situationText: preEnergizationFormException.situation });
      this.setState({ timelineText: preEnergizationFormException.timeline });
      this.setState({ protectionSystemText: preEnergizationFormException.protectionSystem });
      this.setState({ ddcSystemText: preEnergizationFormException.ddcsystem });
      this.setState({ resolutionDateText: preEnergizationFormException.resolutionDate });
      this.setState({ primaryContactText: preEnergizationFormException.primaryContact });
      this.setState({ approvalResponseDateText: preEnergizationFormException.approvalResponseDate });
      this.setState({ closedCheckBoxText: preEnergizationFormException.closed !== 'N' });
      this.setState({ statusText: preEnergizationFormException.status });
      this.setState({ teamMembers: preEnergizationFormException.teams ? preEnergizationFormException.teams : await getTeamMembers(this.props.projectId) });
      this.setState({ exceptionId: preEnergizationFormException.preEnergizationFormExceptionId });
      this.setState({ preEAttachments: this.props.attachments });
      this.setState({preFormExceptionMappings: preEnergizationFormException.preFormExceptionMappings})
      this.setState({selectedLocationAssets: this.filterSelectedAssets(preEnergizationFormException.preFormExceptionMappings)
      })
      spinnerOff();
    }

  }
  filterSelectedAssets(locations) {
    const selectedAssets = locations.map(location=> ({ipsLocationId: location.ipsLocationId, assetIds:location.assets.map(asset=> asset.assetId)}))
    return selectedAssets? selectedAssets: []
  }

  hideButtonGroup() {
    document.getElementById('preE-confirmation-save-button').classList.add('disabledbutton');
    document.getElementById('preE-confirmation-cancel-button').classList.add('disabledbutton');

  }

  unhideButtonGroup() {
    document.getElementById('preE-confirmation-save-button').classList.remove('disabledbutton');
    document.getElementById('preE-confirmation-cancel-button').classList.remove('disabledbutton');
  }

  handleCheckboxSelect(asset){
    let selectedLocationAssets = []
    if( this.state.selectedLocationAssets.length==0) {
      this.setState({selectedLocationAssets: [{ipsLocationId: asset.ipsLocationId, assetIds: [asset.assetId]}]})
      
    } else {
      const locations = this.state.selectedLocationAssets.filter(l=> l.ipsLocationId===asset.ipsLocationId)
      let location = null;
      if(locations.length>0) {
        location = locations[0].assetIds.includes(asset.assetId)? 
        {ipsLocationId:locations[0].ipsLocationId, assetIds: locations[0].assetIds.filter(id=> id!=asset.assetId)}
        : 
        {ipsLocationId:locations[0].ipsLocationId, assetIds: [...locations[0].assetIds, asset.assetId]}
        this.state.selectedLocationAssets.map(l=> l.ipsLocationId==location.ipsLocationId? location: l)
        this.setState({selectedLocationAssets: this.state.selectedLocationAssets.map(l=> l.ipsLocationId==location.ipsLocationId? location: l)})
      } else {  
        this.setState({selectedLocationAssets: [...this.state.selectedLocationAssets, {ipsLocationId: asset.ipsLocationId, assetIds: [asset.assetId]}]})
      }
      
    }
  }

  handleIpsLocationSelect =(location) => {

    const locations = this.state.selectedLocationAssets.length>0 ?this.state.selectedLocationAssets.map(loc => loc.ipsLocationId===location.ipsLocationId? {ipsLocationId: location.ipsLocationId, assetIds: location.assets.map(asset=> asset.assetId)}
    : loc)
    : [{ipsLocationId: location.ipsLocationId, assetIds: location.assets.map(asset=> asset.assetId)}]

    locations.filter(loc=> loc.ipsLocationId!=location.ipsLocationId).length>0 && locations.push( {ipsLocationId: location.ipsLocationId, assetIds: location.assets.map(asset=> asset.assetId)})
    
    const isAllSelected = this.state.selectedLocationAssets.length>0 ? this.state.selectedLocationAssets.filter(loc => loc.ipsLocationId === location.ipsLocationId && loc.assetIds.length ===location.assets.length).length>0: false
      if(isAllSelected){
        this.setState({selectedLocationAssets: this.state.selectedLocationAssets.filter(loc=> loc.ipsLocationId!=location.ipsLocationId)})
      } else {
      this.setState({selectedLocationAssets: locations})
    }
  }

  render() {
    const { preEFormException } = this.state;
    return (
      <PreEExceptDialog
        onSave={async () => {
          this.savePreEFormExceptionDialog();
        }}
        onEdit={async () => {
          this.editPreEFormExceptionDialog();
        }}
        onDelete={async () => {
          this.deletePreEFormExceptionDialog();
        }}
        onChangeTitleTextChg={this.onChangeTitleTextChg}
        onChangeSituationTextChg={this.onChangeSituationTextChg}
        onChangeTimeLineTextChg={this.onChangeTimeLineTextChg}
        onChangeProtectionRadioButtonChange={this.onChangeProtectionRadioButtonChange}
        onChangeDDCRadioButtonChange={this.onChangeDDCRadioButtonChange}
        onChangePrimaryContact={this.onChangePrimaryContact}
        onChangeClosedCheckBox={this.onChangeClosedCheckBox}
        onChangeResolutionDate={this.onChangeResolutionDate}
        onChangeApprovalResponseDate={this.onChangeApprovalResponseDate}
        handleselectedFile={(files) => this.handleselectedFile(files)}
        handleFile={(file, event) => this.handleFile(file, event)}
        deleteSelectedFile={(fileName, event) => this.deleteSelectedFile(fileName, event)}

        titleText={this.state.titleText}
        situationText={this.state.situationText}
        timelineText={this.state.timelineText}
        protectionSystemText={this.state.protectionSystemText}
        ddcSystemText={this.state.ddcSystemText}
        statusText={this.state.statusText}
        primaryContactText={this.state.primaryContactText}
        resolutionDateText={this.state.resolutionDateText}
        approvalResponseDateText={this.state.approvalResponseDateText}
        closedCheckBoxText={this.state.closedCheckBoxText}
        exceptionId={this.state.exceptionId}
        viewOnly={this.props.viewOnly}
        teams={this.props.teams}
        onClose={this.props.onClose}
        teamMembers={this.props.teams}
        projectId={this.props.projectId}
        error={this.state.error}
        isCreatorAdminIntCont={this.props.isCreatorAdminIntCont}
        isExternalContributor = {this.props.isExternalContributor}
        editVisibleProps={this.state.editVisibleText}
        editVisible={this.state.editVisibleText}
        newFormSaveVisibleText={this.state.newFormSaveVisibleText}
        approvedStatus={this.state.statusText === 'Approved' || this.state.statusText === 'Denied'}
        isApproved={this.state.statusText === 'Approved'}
        energized={this.props.energized}
        waitingStatus={this.state.statusText === 'Waiting on Response(s)'}
        fileList={this.state.fileList}
        fileCount={this.state.fileCount}
        fileSize={this.state.fileSize}
        noOfFilesError={this.state.noOfFilesError}
        filesizeOk={this.state.filesizeOk}
        preEAttachments={this.state.preEAttachments}
        preFormMappings={this.state?.preEnergizationFormException?.preFormMappings}
        handleCheckboxSelect = {this.handleCheckboxSelect}
        handleIpsLocationSelect = {this.handleIpsLocationSelect}
        selectedLocationAssets= {this.state.selectedLocationAssets}
        exceptionViewMode={this.props.exceptionViewMode}
        preFormExceptionMappings={this.state.preFormExceptionMappings}
      />

    );
  }


  onChangeSituationTextChg = (e) => {
    const value = e.target.value === null ? '' : e.target.value;
    this.setState({ situationText: value });
  };
  onChangeTitleTextChg = (e) => {
    const value = e.target.value === null ? '' : e.target.value;
    this.setState({ titleText: value });
  };
  onChangeTimeLineTextChg = (e) => {
    const value = e.target.value === null ? '' : e.target.value;
    this.setState({ timelineText: value });
  };
  onChangeProtectionRadioButtonChange = (e) => {
    const value = e.target.value;
    let dbValue;
    dbValue = (value === 1) ? 'Y' : 'N';
    this.setState({ protectionSystemText: dbValue });
  };
  onChangeDDCRadioButtonChange = (e) => {
    const value = e.target.value;
    let dbValue;
    dbValue = (value === 1) ? 'Y' : 'N';
    this.setState({ ddcSystemText: dbValue });
  };
  onChangePrimaryContact = (e) => {
    const value = e.target.value;
    this.setState({ primaryContactText: value });
  };
  onChangeResolutionDate = (e) => {
    let myDate = null;
    if (e) {
      myDate = e.format('MMMM DD, YYYY');
    }
    this.setState({ resolutionDateText: myDate });
  };

  onChangeApprovalResponseDate = (e) => {
    let myDate = null;
    if (e) {
      myDate = e.format('MMMM DD, YYYY');
    }
    this.setState({ approvalResponseDateText: myDate });
  };

  onChangeClosedCheckBox = (e) => {
    const value = e.target.checked;
    this.setState({
      closedCheckBoxText: value
    });
  };

  handleError(error) {
    this.setState({ error });
    document.getElementById('preE--exception--form').scrollTo(0, 0);
  }

  async savePreEFormExceptionDialog() {
    const { preEnergizationFormException } = this.state;
    const { updateExceptionsState } = this.props;
    let updatedPreException = { ...preEnergizationFormException };

    updatedPreException.title = this.state.titleText;
    updatedPreException.situation = this.state.situationText;
    updatedPreException.timeline = this.state.timelineText;
    updatedPreException.protectionSystem = this.state.protectionSystemText;
    updatedPreException.ddcsystem = this.state.ddcSystemText;
    updatedPreException.resolutionDate = this.state.resolutionDateText;
    updatedPreException.primaryContact = this.state.primaryContactText;
    updatedPreException.approvalResponseDate = this.state.approvalResponseDateText;
    updatedPreException.closed = this.state.closedCheckBoxText ? 'Y' : 'N';
    updatedPreException.preEnergizationFormExceptionId = this.state.exceptionId;

    const request = { preEnergizationFormException: updatedPreException };

    if (!request.preEnergizationFormException.title) {
      this.handleError('Please Enter Exception Title');
      return;
    }
    if (!request.preEnergizationFormException.protectionSystem) {
      this.handleError('Please Select Protection System');
      return;
    }
    if (!request.preEnergizationFormException.ddcsystem) {
      this.handleError('Please Select DDC System');
      return;
    }
    if (!request.preEnergizationFormException.situation) {
      this.handleError('Please Enter Situation Requiring Exception');
      return;
    }

    if (!request.preEnergizationFormException.timeline) {
      this.handleError('Please Enter Timeline for Remaining Work');
      return;
    }

    if (!request.preEnergizationFormException.resolutionDate) {
      this.handleError('Please Enter Expected Resolution Date');
      return;
    }
    if (!request.preEnergizationFormException.primaryContact || document.getElementById('drop-down-primary-contact').value === '') {
      this.handleError('Please Select Primary Contact');
      return;
    }

    if (!request.preEnergizationFormException.approvalResponseDate) {
      this.handleError('Please Select Approvals Response Needed By');
      return;
    }
   
    if(this.state.selectedLocationAssets.length==0){
      
      this.handleError('Please select at least one Asset')
      return;
    }

    this.handleSaveExceptions({...request, selectedIpsLocations: this.state.selectedLocationAssets});

  }

  async editPreEFormExceptionDialog() {
    this.setState({
      editVisibleText: !(this.state.exceptionId !== null)
    });
  }

  async deletePreEFormExceptionDialog() {
    this.props.deleteException();
  }

  async handleselectedFile(event) {
    this.setState({ filesizeOk: true });
    await this.setState({
      fileList: event.target.files
    });
    let fileCount = this.state.preEAttachments.length + this.state.fileList.length;
    this.setState({ fileCount });
  }

  async handleSaveExceptions(request) {
    const { updateFormState } = this.props;
    const { fileList, preEAttachments, fileCount } = this.state;
    if (fileList.length > 0) {
      let filesizeOk = true;
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size > 100e6) {
          filesizeOk = false;
        }
      }
      this.setState({ filesizeOk });
      if (fileCount < 6) {
        if (filesizeOk === true) {
          await this.handleSaveOnAttachments(request);
        } else {
          this.maxFileSizeError('*You cannot add an attachment more than 100 MB');
        }
      } else {
        this.maxFileCountError('*You cannot add more than 5 attachments');
      }

    } else {
      await this.handleSaveOnAttachments(request);
    }
    updateFormState();
  }

  async handleSaveOnAttachments(request) {
    spinnerOn();
    this.hideButtonGroup();
    const { fileList, preEAttachments } = this.state;
    let response = null;
    let self = this;
    const formId = this.props.formId;
    const files = Object.entries(fileList);
    if (this.props.exceptionId !== null && this.props.formId) {
      let formData = new FormData();
      formData.append('attachments', new Blob([JSON.stringify(preEAttachments)], { type: 'application/json' }));

      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i][1]);
      }

      formData.append('preEnergizationFormException', new Blob([JSON.stringify(request)], {
        type: 'application/json'
      }));
const token = await oktaAuth.getAccessToken();
      await axios({
        url: `/api/projects/preforms/${formId}/exception/update`,
        method: 'post',
        data: formData,
        headers: { 
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  }
      })
        .then((response) => {
          self.setState({ filesizeOk: true });
        })
        .catch(function(response) {
        });
    } else {
      let formData = new FormData();
      formData.append('preEnergizationFormException', new Blob([JSON.stringify(request)], {
        type: 'application/json'
      }));

      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i][1]);
      }
      const token = await oktaAuth.getAccessToken();
      
      await axios({
  method: 'post',
  url: `/api/projects/preforms/exception/create`,
  data: formData,
  headers: { 
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'multipart/form-data'
  }
})
        .then((response) => {
          self.setState({ filesizeOk: true });
        })
        .catch(function(response) {
          spinnerOff();
        });

    }
    this.props.updateState(request);
    spinnerOff();
    this.unhideButtonGroup();
    this.props.onClose();
  }

  maxFileSizeError(fileSize) {
    this.setState({ fileSize });
  }

  maxFileCountError(noOfFilesError) {
    this.setState({ noOfFilesError });
  }

  handleFile(file, event) {
    const fileData = file.fileData;
    let tempArr = this.base64ToArrayBuffer(fileData);
    event.preventDefault();
    this.downloadToClient(fileData, tempArr, file);
  }

  base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  downloadToClient(fileData, byte, file) {
    let blob = new Blob([byte], { type: 'application/octet-stream' });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = file.fileName;
    link.click();

  }

  async deleteSelectedFile(fileName, event) {
    event.preventDefault();
    this.deleteFile(fileName);
  }

  async deleteFile(fileName) {
    let attachmentsList = this.state.preEAttachments.filter(file => {
      return file.fileName !== fileName ? file : null;
    });
    this.setState({ preEAttachments: attachmentsList });

  }
}

const ShowPreEExceptionDialog = (preEFormData) => {
  const options = {
    closeOnEscape: true,
    closeOnClickOutside: false,
    customUI: (props) => <PreEExceptionDialog
      {...props}
      {...preEFormData}
    />
  };
  confirmAlert(options);
};

export default ShowPreEExceptionDialog;
